<template>
  <v-card class="create-nsr-item">
    <v-card-title>
      {{ $t("nsr_item.edit_title") }}
    </v-card-title>

    <v-card-text class="d-flex flex-column overflow-auto">
      <v-form ref="form">
        <v-text-field
          outlined
          style="margin-top: 0.75rem"
          :label="$t('nsr_item.item_no')"
          v-model="item.item_no"
          :rules="requiredRules"
        ></v-text-field>
        <v-text-field
          outlined
          :label="$t('nsr_item.action_description')"
          v-model="item.action_description"
        ></v-text-field>
        <v-text-field
          outlined
          :label="$t('nsr_item.work_order_no')"
          v-model="item.work_order_no"
        ></v-text-field>
        <v-row>
          <v-col cols="4">
            <v-select
              outlined
              :label="$t('nsr_item.unit_id')"
              :items="unitIdOptions"
              v-model="item.unit_id"
              :rules="requiredRules"
            ></v-select>
          </v-col>
          <v-col cols="8">
            <v-text-field
              outlined
              :label="$t('nsr_item.unit')"
              v-model="item.unit"
              :rules="requiredRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          outlined
          type="number"
          min="0"
          step=".01"
          :label="$t('nsr_item.value')"
          v-model="item.value"
          :rules="requiredRules"
        ></v-text-field>
        <!-- <v-text-field
          v-if="item.saved"
          outlined
          type="number"
          min="0"
          step=".01"
          :label="$t('nsr_item.value')"
          v-model="roundedValue"
          disabled
        ></v-text-field> -->
        <v-row>
          <v-col cols="8">
            <v-text-field
              outlined
              :label="$t('nsr_item.contract_no')"
              v-model="item.contract_no"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              outlined
              :label="$t('nsr_item.contract_year')"
              :items="contractYearOptions"
              v-model="item.contract_year"
              :rules="item.contract_no ? requiredRules : []"
            ></v-select>
          </v-col>
        </v-row>
        <DatePickerInput
          :label="$t('nsr_item.request_date')"
          :hide-details="false"
          v-model="item.request_date"
        ></DatePickerInput>
        <DatePickerInput
          :label="$t('nsr_item.approval_date')"
          :hide-details="false"
          v-model="item.approval_date"
        ></DatePickerInput>
        <v-text-field
          outlined
          type="number"
          min="0"
          step=".01"
          :label="$t('nsr_item.contractor_claim')"
          v-model="item.contractor_claim"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api/dist/vue-composition-api";
import { ACTION_TYPES } from "@/store/types";
import DatePickerInput from "@/components/DatePickerInput";
import { onMounted } from "@vue/composition-api";
import { DateTime } from "luxon";

export default {
  name: "EditNsrItemDialog",
  components: { DatePickerInput },
  props: {
    nsrItem: Object,
  },
  setup(props, { root, emit }) {
    const roundedValue = ref(0);
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const item = ref({});

    const unitIdOptions = ref([
      { text: "A", value: "A" },
      { text: "B", value: "B" },
      { text: "C", value: "C" },
      { text: "D", value: "D" },
      { text: "E", value: "E" },
    ]);
    const contractYearOptions = ref(["A", "B", "C", "D", "E"]);

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/nsr/edit/",
        params: {
          ...item.value,
          item_id: props.nsrItem.id,
          call_from: "EDIT",
        },
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    onMounted(() => {
      item.value = {
        ...props.nsrItem,
        request_date: props.nsrItem.request_date
          ? root.$parseDate(props.nsrItem.request_date, "yyyy-MM-dd")
          : null,
        approval_date: props.nsrItem.approval_date
          ? root.$parseDate(props.nsrItem.approval_date, "yyyy-MM-dd")
          : null,
      };

      if (item.value.saved) {
        if (item.value.value && item.value.rounding) {
          roundedValue.value = root
            .$roundNumber(item.value.value, item.value.rounding)
            .toFixed(2);
        }
      }
    });

    return {
      requiredRules,
      item,
      unitIdOptions,
      contractYearOptions,
      save,
      roundedValue,
    };
  },
};
</script>
<style lang="less">
.create-nsr-item {
  display: flex;
  flex-direction: column;
  height: 90vh;
}
</style>
